import { GroupedTableColumn } from "../../../common/components/functional/GroupedTable/GroupedTable";
import { ItemGroupLoadingState } from "../../invoices/invoiceAPI";
import { TalentStatus } from "../../talents/types/common";

export const MOCK_PICKED_TALENTS = {
  candidates: [
    {
      talentId: "426b33bb-6430-4a0c-a629-21c47576dde6",
      firstName: "Jussi",
      lastName: "Tyynelä-TEST",
      picked: {
        userId: "deadbeef",
        firstName: "unknown",
        lastName: "unknown",
        at: 1722418441737,
      },
      interested: {
        userId: "deadbeef",
        firstName: "unknown",
        lastName: "unknown",
        at: 1722418400000,
      },
      introduced: {
        userId: "deadbeef",
        firstName: "unknown",
        lastName: "unknown",
        at: 1722418400000,
      },
      customerAccepted: {
        userId: "deadbeef",
        firstName: "unknown",
        lastName: "unknown",
        at: 1722418400000,
      },
      offered: {
        userId: "deadbeef",
        firstName: "unknown",
        lastName: "unknown",
        at: 1722418441737,
      },
      talentAccepted: {
        userId: "deadbeef",
        firstName: "unknown",
        lastName: "unknown",
        at: 1722418400000,
      },
      eezyRejected: {
        userId: "deadbeef",
        firstName: "unknown",
        lastName: "unknown",
        at: 1722418400000,
      },
      workAgreementId:
        "dgMngsDxiyOgey8GQp3ooQ_426b33bb-6430-4a0c-a629-21c47576dde6",
    },
    {
      talentId: "a1b23cd4-5678-90ab-cdef-1234567890ab",
      firstName: "Matti",
      lastName: "Meikäläinen",
      interested: {
        userId: "user123",
        firstName: "John",
        lastName: "Doe",
        at: 1722418400000,
      },
      introduced: {
        userId: "user456",
        firstName: "Jane",
        lastName: "Doe",
        at: 1722418420000,
      },
      customerAccepted: {
        userId: "user789",
        firstName: "Jim",
        lastName: "Beam",
        at: 1722418440000,
      },
      offered: {
        userId: "user101",
        firstName: "Jack",
        lastName: "Daniels",
        at: 1722418460000,
      },
      talentAccepted: {
        userId: "user102",
        firstName: "Johnny",
        lastName: "Walker",
        at: 1722418480000,
      },
      workAgreementId: "work1234",
    },
    {
      talentId: "b2c34de5-6789-01bc-ddef-2345678901bc",
      firstName: "Maija",
      lastName: "Mallikas",
      interested: {
        userId: "user234",
        firstName: "Alice",
        lastName: "Smith",
        at: 1722418500000,
      },
      introduced: {
        userId: "user345",
        firstName: "Bob",
        lastName: "Brown",
        at: 1722418520000,
      },
      offered: {
        userId: "user456",
        firstName: "Charlie",
        lastName: "White",
        at: 1722418540000,
      },
      talentAccepted: {
        userId: "user567",
        firstName: "David",
        lastName: "Black",
        at: 1722418560000,
      },
      eezyRejected: {
        userId: "user678",
        firstName: "Eve",
        lastName: "Green",
        at: 1722418580000,
      },
      workAgreementId: "work5678",
    },
    {
      talentId: "c3d45ef6-7890-12cd-efef-3456789012cd",
      firstName: "Seppo",
      lastName: "Saapas",
      picked: {
        userId: "user345",
        firstName: "Carol",
        lastName: "Johnson",
        at: 1722418600000,
      },
      customerAccepted: {
        userId: "user456",
        firstName: "Dan",
        lastName: "Brown",
        at: 1722418620000,
      },
      offered: {
        userId: "user567",
        firstName: "Eve",
        lastName: "Taylor",
        at: 1722418640000,
      },
      workAgreementId: "work8901",
    },
    {
      talentId: "d4e56f78-9012-34de-fgfg-4567890123de",
      firstName: "Kaisa",
      lastName: "Kustaa",
      interested: {
        userId: "user567",
        firstName: "Fay",
        lastName: "Moore",
        at: 1722418660000,
      },
      introduced: {
        userId: "user678",
        firstName: "Gary",
        lastName: "Lee",
        at: 1722418680000,
      },
      talentAccepted: {
        userId: "user789",
        firstName: "Hannah",
        lastName: "Davis",
        at: 1722418700000,
      },
      eezyRejected: {
        userId: "user890",
        firstName: "Isaac",
        lastName: "Martinez",
        at: 1722418720000,
      },
      workAgreementId: "work2345",
    },
    {
      talentId: "e5f67g89-0123-45ef-ghgh-5678901234ef",
      firstName: "Lauri",
      lastName: "Lepistö",
      picked: {
        userId: "user789",
        firstName: "Ivy",
        lastName: "Anderson",
        at: 1722418740000,
      },
      introduced: {
        userId: "user890",
        firstName: "Jack",
        lastName: "Harris",
        at: 1722418760000,
      },
      offered: {
        userId: "user901",
        firstName: "Kara",
        lastName: "Clark",
        at: 1722418780000,
      },
      eezyRejected: {
        userId: "user012",
        firstName: "Leo",
        lastName: "Lewis",
        at: 1722418800000,
      },
      workAgreementId: "work6789",
    },
    {
      talentId: "e5f67g89-0123-45ef-ghgh-567890123456",
      firstName: "Tyhjä",
      lastName: "Status",
      workAgreementId: "work6789",
    },
  ],
};

export const TALENTS_STATUS_COLUMNS: GroupedTableColumn[] = [
  {
    // TODO when YLPE-1921 is done, change to "fullName"
    fieldName: "displayName",
    displayName: "",
    width: "31,5%",
    disableTooltip: true,
    headerSx: {
      padding: "8px 0px",
    },
  },
  {
    fieldName: "link",
    displayName: "",
    width: "auto",
    disableTooltip: true,
    align: "right",
    sx: {
      paddingRight: "10px",
      whiteSpace: "nowrap",
      width: 140,
      color: "text.secondary",
      maxWidth: 150,
      overflowWrap: "break-word",
      hyphens: "auto",
      overflow: "visible",
    },
    headerSx: {
      padding: "8px 0px",
    },
  },
  {
    fieldName: "appliedAt",
    displayName: "appliedAt",
    width: "auto",
    align: "center",
    sx: {
      padding: "8px 0px",
      width: 75,
      maxWidth: 75,
      color: "text.secondary",
      hyphens: "auto",
      overflow: "visible",
      borderLeft: "1px solid #000A441C",
      borderRight: "1px solid #000A441C",
    },
    headerSx: {
      width: 75,
      maxWidth: 75,
      color: "text.secondary",
      verticalAlign: "bottom",
      overflowWrap: "break-word",
      borderLeft: "1px solid #000A441C",
      borderRight: "1px solid #000A441C",
      padding: "8px 0px",
    },
  },
  {
    fieldName: "interestAsked",
    displayName: "asked",
    width: "auto",
    align: "center",
    sx: {
      padding: "8px 0px",
      width: 67,
      maxWidth: 67,
      hyphens: "auto",
      overflow: "visible",
      borderLeft: "1px solid #000A441C",
      borderRight: "1px solid #000A441C",
    },
    headerSx: {
      width: 67,
      maxWidth: 67,
      color: "text.secondary",
      verticalAlign: "bottom",
      overflowWrap: "break-word",
      borderLeft: "1px solid #000A441C",
      borderRight: "1px solid #000A441C",

      padding: "8px 0px",
    },
    isTimeline: true,
  },
  {
    fieldName: "interested",
    displayName: "interested",
    width: "auto",
    align: "center",
    sx: {
      padding: "8px 0px",
      width: 67,
      maxWidth: 67,
      borderLeft: "1px solid #000A441C",
      borderRight: "1px solid #000A441C",
    },
    headerSx: {
      width: 67,
      maxWidth: 67,
      color: "text.secondary",
      verticalAlign: "bottom",
      overflowWrap: "break-word",
      hyphens: "auto",
      overflow: "visible",
      borderLeft: "1px solid #000A441C",
      borderRight: "1px solid #000A441C",
      lineHeight: "15.4px",

      padding: "8px 0px",
    },
    isTimeline: true,
  },
  {
    fieldName: "introduced",
    displayName: "introduced",
    width: "auto",
    align: "center",
    sx: {
      padding: "8px 0px",
      width: 67,
      maxWidth: 67,
      borderLeft: "1px solid #000A441C",
      borderRight: "1px solid #000A441C",
    },
    headerSx: {
      width: 67,
      maxWidth: 67,
      color: "text.secondary",
      verticalAlign: "bottom",
      overflowWrap: "break-word",
      hyphens: "auto",
      overflow: "visible",
      borderLeft: "1px solid #000A441C",
      borderRight: "1px solid #000A441C",

      padding: "8px 0px",
    },
    isTimeline: true,
  },
  {
    fieldName: "chosenForInterview",
    displayName: "chosenForInterview",
    width: "auto",
    align: "center",
    sx: {
      padding: "8px 0px",
      width: 67,
      maxWidth: 67,
      borderLeft: "1px solid #000A441C",
      borderRight: "1px solid #000A441C",
    },
    headerSx: {
      width: 67,
      maxWidth: 67,
      color: "text.secondary",
      verticalAlign: "bottom",
      overflowWrap: "break-word",
      hyphens: "auto",
      overflow: "visible",
      borderLeft: "1px solid #000A441C",
      borderRight: "1px solid #000A441C",
      lineHeight: "15.4px",

      padding: "8px 0px",
    },
    isTimeline: true,
  },
  {
    fieldName: "customerApproved",
    displayName: "customerApprovedDisplayName",
    width: "auto",
    align: "center",
    sx: {
      padding: "8px 0px",
      width: 67,
      maxWidth: 67,
      borderLeft: "1px solid #000A441C",
      borderRight: "1px solid #000A441C",
    },
    headerSx: {
      width: 67,
      maxWidth: 67,
      color: "text.secondary",
      verticalAlign: "bottom",
      overflowWrap: "break-word",
      hyphens: "auto",
      overflow: "visible",
      borderLeft: "1px solid #000A441C",
      borderRight: "1px solid #000A441C",
      lineHeight: "15.4px",

      padding: "8px 0px",
    },
    isTimeline: true,
  },
  {
    fieldName: "offered",
    displayName: "offeredDisplayName",
    width: "auto",
    align: "center",
    sx: {
      padding: "8px 0px",
      width: 67,
      maxWidth: 67,
      borderLeft: "1px solid #000A441C",
      borderRight: "1px solid #000A441C",
    },
    headerSx: {
      width: 67,
      maxWidth: 67,
      color: "text.secondary",
      verticalAlign: "bottom",
      overflowWrap: "break-word",
      hyphens: "auto",
      overflow: "visible",
      borderLeft: "1px solid #000A441C",
      borderRight: "1px solid #000A441C",
      lineHeight: "15.4px",

      padding: "8px 0px",
    },
    isTimeline: true,
  },
  {
    fieldName: "workAgreementAccepted",
    displayName: "workAgreementAccepted",
    width: "auto",
    align: "center",
    sx: {
      padding: "8px 0px",
      width: 67,
      maxWidth: 67,
      borderLeft: "1px solid #000A441C",
      borderRight: "1px solid #000A441C",
    },
    headerSx: {
      width: 67,
      maxWidth: 67,
      color: "text.secondary",
      verticalAlign: "bottom",
      overflowWrap: "break-word",
      hyphens: "auto",
      overflow: "visible",
      borderLeft: "1px solid #000A441C",
      borderRight: "1px solid #000A441C",
      borderBottom: "1px solid #000A441C",
      padding: "8px 0px",
    },
    isTimeline: true,
  },
  {
    fieldName: "eezyRejected",
    displayName: "eezyRejected",
    width: "auto",
    align: "center",
    sx: {
      padding: "8px 0px",
      width: 67,
      maxWidth: 67,
      color: "text.secondary",
      overflowWrap: "break-word",
      hyphens: "auto",
      overflow: "visible",
      borderLeft: "1px solid #000A441C",
    },
    headerSx: {
      width: 67,
      maxWidth: 67,
      color: "text.secondary",
      verticalAlign: "bottom",
      overflowWrap: "break-word",
      hyphens: "auto",
      overflow: "visible",
      borderLeft: "1px solid #000A441C",
      lineHeight: "15.4px",

      padding: "8px 0px",
    },
    isTimeline: true,
  },
  {
    fieldName: "withdrew",
    displayName: "withdrew",
    width: "auto",
    align: "center",
    sx: {
      padding: "8px 0px",
      width: 67,
      maxWidth: 67,
      color: "text.secondary",
      overflowWrap: "break-word",
      hyphens: "auto",
      overflow: "visible",
      borderLeft: "1px solid #000A441C",
    },
    headerSx: {
      width: 67,
      maxWidth: 67,
      color: "text.secondary",
      verticalAlign: "bottom",
      overflowWrap: "break-word",
      hyphens: "auto",
      overflow: "visible",
      borderLeft: "1px solid #000A441C",
      lineHeight: "15.4px",

      padding: "8px 0px",
    },
    isTimeline: true,
  },
];

export enum CandidateStatusGroupName {
  SEARCH = "search",
  PICKED = "picked",
  JOB_AD = "fromJobAdvertisement",
  RECOMMENDED_NEW = "recommendedNew",
  RECOMMENDED = "recommended",
  REJECTED = "eezyRejected",
  WITHDREW = "withdrew",
}

export enum CandidateStatus {
  Picked = "picked",
  InterestAsked = "interestAsked",
  Interested = "interested",
  Introduced = "introduced",
  ChosenForInterview = "chosenForInterview",
  CustomerApproved = "customerApproved",
  CustomerRejected = "customerRejected",
  Offered = "offered",
  WorkAgreementAccepted = "workAgreementAccepted",
  EezyRejected = "eezyRejected",
  Withdrew = "withdrew",

  // Only for UI purposes
  Rejected = "rejected",
  Default = "default",
}

export enum CandidateStatusAction {
  PICK = "pick",
  UNPICK = "unpick",
  ASK_FOR_INTEREST = "ask",
  CHOOSE_FOR_INTRODUCTION = "introduce",
  CANCEL_INTRODUCTION = "cancelIntroduction",
  CHOOSE_FOR_INTERVIEW = "chooseForInterview",
  CUSTOMER_APPROVED = "customerApproved",
  CUSTOMER_REJECTED = "customerRejected",
  SEND_WORK_OFFER = "sendWorkOffer",
  SEND_REJECTED_MESSAGE = "sendRejectedMessage",
  CANCEL_REJECTION = "cancelRejection",
  NOT_SUITABLE = "notSuitable",
  WITHDREW = "withdrew",
  CANCEL_WITHDRAWAL = "cancelWithdrawal",
}

export const TALENTS_STATUS_GROUPS_DEFAULT_VALUES = [
  {
    name: CandidateStatusGroupName.SEARCH,
    items: [],
    status: ItemGroupLoadingState.IDLE,
  },
  {
    name: CandidateStatusGroupName.PICKED,
    secondaryTextKey: "order:pickedByExpert",
    items: [],
    status: ItemGroupLoadingState.PENDING,
  },
  {
    name: CandidateStatusGroupName.JOB_AD,
    secondaryTextKey: "order:appliedByTalent",
    items: [],
    status: ItemGroupLoadingState.IDLE,
  },
  {
    name: CandidateStatusGroupName.RECOMMENDED,
    subgroupTitleKeys: {
      1: "order:recommendedSkillsAndRequirements",
      2: "order:recommendedRequirements",
      3: "order:recommendedMissingRequirements",
      4: "order:recommendedOver50Km",
    },
    secondaryTextKey: "order:talentsSuggestedBySystem",
    items: [],
    status: ItemGroupLoadingState.PENDING,
  },
  {
    name: CandidateStatusGroupName.RECOMMENDED_NEW,
    subgroupTitleKeys: {
      1: "order:recommendedNewSkillsAndRequirements",
      2: "order:recommendedNewRequirements",
      3: "order:recommendedNewMissingRequirements",
      4: "order:recommendedNewOver50Km",
    },
    secondaryTextKey: "order:talentsSuggestedBySystem",
    items: [],
    status: ItemGroupLoadingState.PENDING,
  },
  {
    name: CandidateStatusGroupName.REJECTED,
    items: [],
    status: ItemGroupLoadingState.PENDING,
  },
  {
    name: CandidateStatusGroupName.WITHDREW,
    items: [],
    status: ItemGroupLoadingState.PENDING,
  },
];

export enum TalentStatusDialogContent {
  ASK_FOR_INTEREST = "ASK_FOR_INTEREST",
  SEARCH_OTHER_CANDIDATES = "SEARCH_OTHER_CANDIDATES",
  CHOOSE_FOR_INTRODUCTION = "CHOOSE_FOR_INTRODUCTION",
  CHOOSE_FOR_INTERVIEW = "CHOOSE_FOR_INTERVIEW",
  WITHDREW = "WITHDREW",
  NOT_SUITABLE = "NOT_SUITABLE",
  CUSTOMER_REJECTED = "CUSTOMER_REJECTED",
}

export const CANDIDATE_STATUS_SORT_ORDER = [
  CandidateStatus.WorkAgreementAccepted,
  CandidateStatus.Offered,
  CandidateStatus.CustomerApproved,
  CandidateStatus.Introduced,
  CandidateStatus.ChosenForInterview,
  CandidateStatus.Interested,
  CandidateStatus.InterestAsked,
  CandidateStatus.Picked,
  CandidateStatus.EezyRejected,
  CandidateStatus.Withdrew,
];

export const TALENT_STATUS_SORT_ORDER = [
  TalentStatus.ACTIVE,
  TalentStatus.NEW,
  TalentStatus.LATER,
];
